import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    align-items: center;
    line-height: 1.5rem;

    & > div {
        margin-right: 1rem;
    }
    & > div:last-child {
        margin-right: 0;
    }
    margin-left: 1rem;
`
export const Icons = styled.div`
    display: flex;
    min-width: 5rem;
    justify-content: space-between;
    align-items: flex-end;
`

export const Like = styled.a`
    position: relative;
    text-decoration: none;
    background-repeat: no-repeat;
    width: 1.9rem;
    height: 1.7rem;
    cursor: ${(props) => props.cursor || 'pointer'};
    background-image: ${(props) =>
        props.isDisabled
            ? `url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/like-default.svg')`
            : `url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/like.svg')`};
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Basket = styled.a`
    position: relative;
    text-decoration: none;
    background-repeat: no-repeat;
    background-image: ${(props) =>
        props.isDisabled
            ? `url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/basket-default.svg')`
            : `url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/basket.svg')`};
    cursor: ${(props) => props.cursor || 'pointer'};
    width: 2.6rem;
    height: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: flex-end;
`

export const PositionsCount = styled.span`
    color: ${ThemeColors.white};
    font-weight: 600;
    font-size: 1rem;
`

export const LikedCount = styled.span`
    color: ${ThemeColors.white};
    font-size: 1rem;
    font-weight: 600;
`

export const BasketSumContainer = styled.div`
    margin: 0;
    position: relative;
    cursor: pointer;
    display: flex;
    & > div {
        margin-right: 1rem;
    }
    & > div:last-child {
        margin-right: 0;
    }
`
export const SumContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
`

export const HRContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`
export const SumTitle = styled.span`
    font-size: 0.82rem;
    color: ${ThemeColors.accentGreen};
`
export const Sum = styled.span`
    white-space: nowrap;
    font-size: 1rem;
    color: ${ThemeColors.blackGreenText};
`
